// extracted by mini-css-extract-plugin
export var avatarContainer = "testimonials-module--avatar-container--273f9";
export var clientInfoContainer = "testimonials-module--client-info-container--5cc0a";
export var slideContainer = "testimonials-module--slide-container--a0745";
export var testimonialContainer = "testimonials-module--testimonial-container--ae601";